import { isClient } from "~/utils/userHelper";

export const PROJECT_TEMPLATE_TASK_LIST = "ProjectTemplateTaskList";
export const PROJECT_TEMPLATE_TASK = "ProjectTemplateTask";
export const PROJECT_TEMPLATE_SUBTASK = "ProjectTemplateSubtask";
export const PROJECT_TEMPLATE_RECURRING_TASK = "ProjectTemplateRecurringTask";
export const PROJECT_TEMPLATE_NOTE = "ProjectTemplateNote";
export const PROJECT_TEMPLATE_DISCUSSION = "ProjectTemplateDiscussion";
export const PROJECT_TEMPLATE_FILE = "ProjectTemplateFile";

export const TEMPLATE_ELEMENTS_LABELS = {
  [PROJECT_TEMPLATE_TASK]: "Task",
  [PROJECT_TEMPLATE_RECURRING_TASK]: "Recurring Task",
  [PROJECT_TEMPLATE_TASK_LIST]: "Task List",
  [PROJECT_TEMPLATE_SUBTASK]: "Subtask",
  [PROJECT_TEMPLATE_DISCUSSION]: "Discussion",
  [PROJECT_TEMPLATE_NOTE]: "Note",
  [PROJECT_TEMPLATE_FILE]: "File",
};

export const resolvedLabel = (type, t, isPlaceholder = false) => {
  const entityName = TEMPLATE_ELEMENTS_LABELS[type] || "Task";

  if (isPlaceholder) {
    if (entityName === "Recurring Task") {
      return t(`Task name`);
    }
    return t(`${entityName} name`);
  }

  return {
    title: t(`Delete ${entityName}`),
    content: t(`${entityName} will be deleted permanently.`),
  };
};

export const resolvePageDetails = (type, t) => {
  if (type === PROJECT_TEMPLATE_NOTE)
    return {
      header: t("Project Template Note not found"),
      name: t("Project Template Note"),
    };
  return { header: t("Project Template Discussion not found"), name: t("Project Template Discussion") };
};

export const resolveStartAndDueOn = (task, t) => {
  const { start_on, due_on } = task;

  if (start_on > 0 && due_on > 0 && start_on !== due_on)
    return t("{{start_on}} - {{due_on}}. day", {
      start_on,
      due_on,
    });
  if ((start_on > 0 && due_on === 0) || (start_on > 0 && due_on > 0 && start_on === due_on))
    return t("{{start_on}}. day", {
      start_on,
    });
  return t("{{due_on}}. day", {
    due_on,
  });
};

export const resolveDueOnTooltipText = (task, t) => {
  const { start_on, due_on } = task;

  if (!start_on && !due_on) {
    return t("Add Date");
  }
  if (start_on > 0 && due_on > 0 && start_on !== due_on) {
    return t("Due from {{start_on}}. to {{due_on}}. day of project", {
      start_on,
      due_on,
    });
  }
  if ((start_on > 0 && due_on === 0) || (start_on > 0 && due_on > 0 && start_on === due_on)) {
    return t("Due on the {{start_on}}. day of project", {
      start_on,
    });
  }
  return t("Due on the {{due_on}}. day of project", {
    due_on,
  });
};

export const resolvedMembersForAssigneePicker = (members, isHiddenFromClients) =>
  isHiddenFromClients ? members.filter((member) => !isClient(member)) : members;
